import React from 'react';
import { useLocation } from 'react-router-dom';
import useScrollReveal from './useScrollReveal';

const BlockText = ({ titleEn, titleCh, contentCh, contentEn, center = true }) => {
  useScrollReveal();
  // 沿用與 Header 相同的判斷邏輯 (中英文切換)
  const location = useLocation();
  const isEnglish = location.pathname.startsWith('/en');

  return (
    <div className={`section-intro ${center ? 'text-center' : ''}`}>
      {isEnglish ? (
        <>
          <h2 className="title-en mb-5 reveal reveal-up">{titleEn}</h2>
        </>
      ) : (
        <>
          <div className="title-en mb-5 reveal reveal-up">{titleEn}</div>
          <h2 className="title-ch mb-30 reveal reveal-up">{titleCh}</h2>
        </>
      )}
      {isEnglish ? (
        <>
          <div className="content-en reveal reveal-up">
            {contentEn}
          </div>
        </>
      ) : (
        <>
          <div className="content-ch mb-10 reveal reveal-up">
            {contentCh}
          </div>
          <div className="content-en reveal reveal-up">
            {contentEn}
          </div>
        </>
      )}
    </div>
  );
};

export default BlockText;